import React from 'react'
import ReactCardFlip from 'react-card-flip'

type Props = {
  isActiveWord: boolean
  isCorrect: boolean
  isFlipped: boolean
  isPresent: boolean
  isSubmitted: boolean
  letter: string
}

const GuessLetter = ({
  isActiveWord,
  isCorrect,
  isFlipped,
  isPresent,
  isSubmitted,
  letter,
}: Props) => {
  const commonStyles = `flex justify-around items-center w-16 h-16 ml-1
    border border-gray-500 border-solid rounded-md text-white text-5xl`

  return (
    <ReactCardFlip isFlipped={isFlipped} flipDirection="vertical">
      <div className={`${commonStyles} ${isActiveWord && 'border-gray-300'}`}>{letter}</div>
      <div
        className={`${commonStyles}
        ${isSubmitted && !isCorrect && !isPresent && 'bg-gray-700'}
        ${isSubmitted && isCorrect && 'bg-green-500'}
        ${isSubmitted && !isCorrect && isPresent && 'bg-yellow-600'}`}
      >
        {letter}
      </div>
    </ReactCardFlip>
  )
}

export default GuessLetter
